import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/atlasContent';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-b border-line bg-surface py-20 lg:py-28" style={{
    paddingTop: "8px",
    paddingBottom: "8px"
  }} data-id="element-13" data-mp="1bmlievk97beo">
      <div className="mx-auto max-w-3xl px-6" data-id="element-14" data-mp="248o8um34gl3z">
        <h2 className="font-serif text-3xl font-semibold tracking-tight text-forest sm:text-4xl" data-id="element-15" data-mp="249zl7aamv16p">
          Fragen, die du haben könntest
        </h2>

        <ul className="mt-10 divide-y divide-line rounded-2xl border border-line bg-surface px-6 shadow-md shadow-forest/10" data-id="element-16" data-mp="1ujwl6q53gmyv">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} data-id="element-17" data-mp="2n70rcyfxb7c8" data-mpi={index}>
                <h3 data-id="element-18" data-mp="2n5z6615714gs">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-6 text-left text-forest transition-colors duration-150 ease-out hover:text-emerald focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald" style={{
                paddingTop: "10px",
                paddingBottom: "10px"
              }} data-id="element-19" data-mp="2ryscuuk82mvi">
                    <span className="text-lg font-medium" data-id="element-20" data-mp="1oj19pgr34ywl">{faq.question}</span>
                    <PlusIcon className={`mt-1 h-5 w-5 shrink-0 text-emerald transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-21" data-mp="1ol49utlyc8f1" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-22" data-mp="1sl4mq9tekbjz">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-23" data-mp="1slo1jhnrajts">
                      <p className="pb-7 pr-12 text-base leading-relaxed text-prose" style={{
                  paddingTop: "0px",
                  paddingBottom: "0px"
                }} data-id="element-24" data-mp="287ixton1an52">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}